import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import backgroundImage from "../../images/location_new/fold2/BgImg03.webp";
import { Link } from "gatsby";

function CaseSection(props) {
  return (
    <div
      className="common_section p-100"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={6} className="my-auto">
            <div className="example" data-text="">
              <h2>Experienced Software Developer in Florida</h2>
            </div>
            <p>
              What works today might not work tomorrow, but TekRevol’s software
              development services are up to date with shifting market trends,
              so when you hire an experienced software developer in Florida from
              TekRevol, you get the assurance that all your project requirements
              will be fulfilled.
            </p>
            <p>
              Our experienced workforce, including software developers,
              designers, and digital marketers, know what it takes to complete a
              task effectively, and project managers ensure that all of it is
              seamlessly processed.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CaseSection;
